export var AccommodationType;
(function (AccommodationType) {
    AccommodationType["HOUSE"] = "house";
    AccommodationType["APARTMENT"] = "apartment";
    AccommodationType["HYBRID"] = "hybrid";
})(AccommodationType || (AccommodationType = {}));
